import { filterUsers } from 'common/api/v1/users';

import {
    FETCH_USERS,
    FETCH_USERS_FAILURE,
    FETCH_USERS_SUCCESS,
} from '../actionTypes';
import { companyUsersActions } from '../reducer';

export default ({ orderBy, page, pageSize, searchText, sortBy, status } = {}) =>
    (dispatch) => {
        dispatch(companyUsersActions[FETCH_USERS]());

        filterUsers({
            orderBy,
            page: page + 1,
            perPage: pageSize,
            searchText,
            sortBy,
            status,
        })
            .then((response) => {
                dispatch(
                    companyUsersActions[FETCH_USERS_SUCCESS](response.data),
                );
            })
            .catch((error) =>
                dispatch(
                    companyUsersActions[FETCH_USERS_FAILURE](
                        error?.response?.data?.errors,
                    ),
                ),
            );
    };
